import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSquareRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0.5 8C0.5 3.85787 3.85786 0.5 8 0.5H40C44.1421 0.5 47.5 3.85786 47.5 8V40C47.5 44.1421 44.1421 47.5 40 47.5H8C3.85787 47.5 0.5 44.1421 0.5 40V8Z",
		stroke: "#082B42"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M22 19.3333L26.6667 24L22 28.6667",
		stroke: "#082B42",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgSquareRight;
